<div class="c-breadcrumb p-flexss u-gap-8">
  <ng-container *ngFor="let item of config">
    <a
      class="c-breadcrumb__item p-flexcs u-gap-8 u-fs-24"
      [routerLink]="item.link"
    >
      <i class="icon-chevron-left"></i>
      <p class="u-fs-16 u-color-primary1">{{ item.title }}</p>
    </a>
  </ng-container>
</div>
